import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, tap, throwError } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { TelemetryService } from '../services/telemetry.service';

export const errorMappingInterceptor: HttpInterceptorFn = (req, next) => {
  const toastr = inject(ToastrService);
  const telemetryService = inject(TelemetryService);

  return next(req).pipe(
    // tap only sees successful (2xx/3xx) HttpResponse events — 4xx/5xx are routed to catchError by Angular
    tap((event) => {
      if (!(event instanceof HttpResponse)) {
        return;
      }
      const correlationId = event.headers?.get('X-Correlation-ID');
      if (correlationId) {
        telemetryService.trackEvent('API_RESPONSE', {
          correlationId,
          status: event.status.toString(),
          url: req.url,
        });
      }
    }),
    catchError((err: HttpErrorResponse) => {
      const errorObj = err instanceof Error ? err : new Error(`HTTP ${err.status}: ${req.url}`);
      telemetryService.trackException(errorObj, {
        url: req.url,
        method: req.method,
        status: err.status.toString(),
        correlationId: err.headers?.get('X-Correlation-ID') ?? '',
      });
      if (err.status === 0) {
        toastr.error('Network error. Check your connection.', 'Error');
      } else if (err.status >= 500) {
        toastr.error('Server error. Please try again later.', 'Error');
      }
      return throwError(() => err);
    }),
  );
};
